import React, { useState } from 'react';
import { Tag } from '../kit';
import { LIMITS, normalizeTags, splitTagInput } from './skillsLogic';

/**
 * Tag entry: Enter or comma adds, Backspace on an empty field removes the
 * last tag, pasted comma/line-separated text becomes several tags. Values are
 * lower-cased like the store does, so what you see is what is saved.
 */
export default function TagInput({ id, value = [], onChange, placeholder, mono = false, label }) {
  const [text, setText] = useState('');
  const full = value.length >= LIMITS.tags;

  const add = (raw) => {
    const parts = splitTagInput(raw);
    if (!parts.length) return;
    onChange(normalizeTags([...value, ...parts]));
    setText('');
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',' || e.key === 'Tab') {
      if (!text.trim()) return;
      e.preventDefault();
      add(text);
    } else if (e.key === 'Backspace' && !text && value.length) {
      e.preventDefault();
      onChange(value.slice(0, -1));
    }
  };

  return (
    <div className={`sk-taginput${mono ? ' sk-mono-tags' : ''}`} onClick={(e) => e.currentTarget.querySelector('input')?.focus()}>
      {value.map((v) => (
        <Tag key={v} onRemove={() => onChange(value.filter((x) => x !== v))} removeLabel={`Remove ${v}`}>{v}</Tag>
      ))}
      <input
        id={id}
        value={text}
        disabled={full}
        aria-label={label}
        placeholder={full ? `Limit of ${LIMITS.tags} reached` : (value.length ? '' : placeholder)}
        onChange={(e) => {
          const v = e.target.value;
          if (/[,\n]/.test(v)) add(v); else setText(v);
        }}
        onKeyDown={onKeyDown}
        onBlur={() => { if (text.trim()) add(text); }}
        onPaste={(e) => {
          const pasted = e.clipboardData?.getData('text') || '';
          if (/[,\n]/.test(pasted)) { e.preventDefault(); add(`${text}${pasted}`); }
        }}
      />
    </div>
  );
}
